module.exports = __webpack_public_path__ + "img/logo_login.2be93762.png";